module.exports = function(rating, countOfReviews, showCount, productFlags, availability) {
  /* PNP-1460: If ShowReviews is true and NOT an active PreOrder and NOT an active Coming Soon product display the reviews count and stars on the Product Tile */
  const showReviews =
    productFlags &&
    Array.isArray(productFlags) &&
    productFlags.filter(function(e) {
      return e.Name === 'Review';
    }).length > 0 &&
    availability.productLifecycle != 'PreOrder' &&
    availability.productLifecycle != 'ComingSoon'
      ? true
      : false;

  /* PNP-1523: Remove product review stars when Availability.Fulfilment = “Digital” and Availability.ProductLifecycle = “PreOrder” */
  const isDigitalPreOrder =
    availability && availability.fulfilment == 'Digital' && availability.productLifecycle == 'PreOrder' ? true : false;

  if (!rating || rating === 0 || !showReviews || isDigitalPreOrder) {
    return;
  }

  const pctRating = Math.round((rating / 5) * 100);
  const count = showCount !== false ? `<span class="review-count">(${countOfReviews})</span>` : '';
  const avgRating =
    rating && !isNaN(rating) ? `<span class="review-rating">${parseFloat(rating).toFixed(1)}</span>` : '';

  return `
    <div class="star-review">
      <span class="stars">
        <span class="stars-full" style="width: ${pctRating}%;"></span>
      </span>
      ${avgRating}
      ${count}
    </div>`;
};
